import { Select } from 'antd';
import { useCallback } from 'react';
import { useRemoteSearchOptions } from '../../../shared/hooks/use-remote-search-options';
import { searchOverrideApprovers } from '../jobs.api';

interface OverrideApproverSelectProps {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

/** Remote-search picker over who holds `override.approve` (gitaumoses4/chukua#36), opening on the first page — same shape as `CustomerSearchSelect`, with no preset-value lookup since an override always starts with no approver chosen. Public because expenses signs off an exception with the same picker (#114). */
export function OverrideApproverSelect({ value, onChange, disabled }: OverrideApproverSelectProps) {
  const fetchApprovers = useCallback(
    (q: string | undefined) =>
      searchOverrideApprovers(q ?? '').then((approvers) =>
        approvers.map((approver) => ({ value: approver.id, label: `${approver.name} (${approver.email})` })),
      ),
    [],
  );
  const { selectProps } = useRemoteSearchOptions(fetchApprovers);

  return (
    <Select
      {...selectProps}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="Select or search who holds override approval"
      notFoundContent={selectProps.loading ? 'Searching…' : 'No one found'}
    />
  );
}
